import { Box, Typography } from "@mui/material"
import type { AnyRoute } from "@tanstack/react-router"
import { createFileRoute, redirect } from "@tanstack/react-router"

import akrochemLogo from "@/images/akrochem_logo.svg"
import { useCurrentUserStore } from "@/stores/currentUserStore"

export const beforeLoad = async (): Promise<void> => {
  const store = useCurrentUserStore.getState()
  const user = await store.getCurrentUser()
  if (user?.isActive) {
    throw redirect({ to: "/" })
  }
}

export const Route: AnyRoute = createFileRoute("/deactivated")({
  beforeLoad,
  component: DeactivatedScreenComponent,
})

function DeactivatedScreenComponent() {
  return (
    <div className='flex size-full items-center justify-center'>
      <div className='flex flex-col items-center justify-center'>
        <Box sx={{ display: "flex", alignItems: "center", mb: 3 }}>
          <img src={akrochemLogo} alt='logo' width={220} height={56} />
        </Box>

        <Typography variant='subtitle1'>Your account is currently de-activated.</Typography>

        <Typography variant='body2' className='text-blue-gray-600'>
          If you believe this is a mistake, please contact your administrator for assistance.
        </Typography>
      </div>
    </div>
  )
}
